import { UPDATE_AI_SWITCH } from '../types'

const state = {
  aiSwitch: null,
}

const getters = {
  aiSwitch: state => state.aiSwitch ? state.aiSwitch : new Map(),
}

const mutations = {
  [UPDATE_AI_SWITCH](state, aiSwitch) {
    state.aiSwitch = aiSwitch
  },
}

export default {
  state,
  getters,
  mutations,
}
